/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerRunPackageComponent', [
    'DesignerComponent',

    function (DesignerComponent) {
      const OPERATOR = {
        AND: 'and',
        OR: 'or',
      };

      function DesignerRunPackageComponent() {
        DesignerComponent.apply(this);

        this.package_id = null;
        this.operator = null;
        this.variables = null;
      }

      DesignerRunPackageComponent.prototype = new DesignerComponent();

      DesignerRunPackageComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          package_id: this.package_id,
          package_name: this.package_name,
          operator: this.operator || OPERATOR.AND,
          variables: this.variables,
        });

        return data;
      };

      DesignerRunPackageComponent.prototype.getFormData = function () {
        const data = DesignerComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerRunPackageComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerRunPackageComponent.prototype.setData = function (data) {
        this.package_id = data.package_id;
        this.operator = data.operator;
        this.variables = data.variables;
        this.package_name = data.package_name;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerRunPackageComponent.prototype.valid = function () {
        return this.package_id !== null && typeof this.package_id === 'number';
      };

      return DesignerRunPackageComponent;
    },
  ]);
})(window.angular);
